<template lang="pug">
  .subscription-step(
    :class="extraClasses"
  )
    .subscription-step__index {{ displayIndex }}
    .subscription-step__content {{ step.content }}
</template>

<script>
  export default {
    name: "SubscriptionStep",
    props: {
      step: Object,
      index: Number,
    },
    data() {
      return {
        loaded: false,
        delay: 450,
      };
    },
    computed: {
      /**
       * Builds the displayable index of the step (starting at 1, not 0)
       *
       * @return {Number}: the displayable index
       */
      displayIndex() {
        return this.index + 1;
      },
      /**
       * Builds the extra classes for the step container based
       * on if the step has loaded or not
       *
       * @return {String}: CSS class for the container
       */
      extraClasses() {
        return this.loaded ? 'subscription-step--loaded' : '';
      },
    },
    /**
     * Set up a timeout to load the step in sequence with the other steps
     * based on their indices
     */
    mounted() {
      const timeout = this.delay * this.displayIndex;
      setTimeout(() => {
        this.loaded = true;
      }, timeout);
    },
  };
</script>

<style lang="scss" scoped>
  .subscription-step {
    position: relative;
    top: 15px;
    padding: 0 9px;
    opacity: 0;
    transition: all .75s;
  }

  .subscription-step--loaded {
    opacity: 1;
    top: 0px;
  }

  .subscription-step__index {
    display: flex;
    margin: 0 auto 25px;
    border: 1px solid $color-indigo;
    border-radius: 100%;
    padding-bottom: 2px;
    width: 55px;
    height: 55px;
    justify-content: center;
    align-items: center;
    font-size: rem(25);
    line-height: 1;
    font-family: $font-acumin-pro;
    color: $color-indigo;
  }

  .subscription-step__content {
    text-align: center;
    font-size: rem(13);
    line-height: 1.5;
    font-family: $font-gibson;
    color: $color-charcoal;
  }
</style>
